import easelAPI, { EaselResponse, getOptions, putOptions, postOptions } from 'apis/helpers/easelAPI'

export const putArtVote = async ({
  collectionIdUserCollection,
  artworkId,
  vote,
}: Record<string, any>): Promise<EaselResponse> => {
  const options = putOptions
  const json = await easelAPI.fetchJSON({
    name: 'putArtVote',
    options,
    url: `/aa/collection/${collectionIdUserCollection}/artwork/${artworkId}/vote/${vote}`,
  })
  return json
}

export const putArtNote = async ({
  collectionId,
  artworkId,
  note,
}: Record<string, any>): Promise<EaselResponse> => {
  const options = {
    ...putOptions,
    body: JSON.stringify({
      note,
    }),
  }
  // console.log('putArtVote', { collectionId, artworkId, note })
  const json = await easelAPI.fetchJSON({
    name: 'putArtNote',
    options,
    url: `/aa/collection/${collectionId}/artwork/${artworkId}/note`,
  })
  // console.log('putArtVote response', { json })
  return json
}

export const postCollectionFeedback = async (
  collectionIdUserCollection: number,
  selectionFeedback: string
): Promise<EaselResponse> => {
  const options = {
    ...postOptions,
    body: JSON.stringify({
      feedback: selectionFeedback,
    }),
  }
  const json = await easelAPI.fetchJSON({
    name: 'postCollectionFeedback',
    options,
    url: `/aa/collection/${collectionIdUserCollection}/feedback`,
  })
  // console.log('postCollectionFeedback response', { json })
  return json
}

export const fetchCollectorVotes = async ({
  collectionId,
  ownerId,
}: Record<string, any>): Promise<EaselResponse> => {
  const options = { ...getOptions }
  // console.log('fetchCollectorVotes', { collectionId, ownerId })
  const json = await easelAPI.fetchJSON({
    name: 'fetchCollectorVotes',
    options,
    url: `/aa/collection/${collectionId}/${ownerId}/meta`,
  })
  // console.log('fetchCollectorVotes response', { json })
  return json
}
